<script>
export default {
  name: 'ComponentsTabs',
  props: {
    tabs: Array,
  },
  data () {
    return {
      component: null,
      activeIndex: 0,
    };
  },
  methods: {
    changeTab (index) {
      if (!this.tabs[index]) {
        return;
      }

      this.component = this.tabs[index].component;
      this.activeIndex = index;
    },
  },
  created () {
    if (!this.tabs) {
      return;
    }

    this.tabs.map((tab, index) => {
      if (tab.active === true) {
        this.component = tab.component;
        this.activeIndex = index;
      }
    });

    if (!this.component) {
      this.component = this.tabs[0].component;
    }
  },
};
</script>
<style lang="scss" scoped>
  @import '../../styles/_variables.scss';
ul {
  border-bottom: 1px solid map-get($colors, silverChalice);
  li {
    &.active {
      border-bottom: 1px solid map-get($colors, mediumSlateBlue);
    }

    a {
      display: block;
      padding: .25rem 1rem;
    }
  }
}
</style>
<template>
  <div>
    <ul class="d-flex">
      <li v-for="(tab, index) in tabs" :key="index" :class="{ active: index === activeIndex }">
        <a class="pointer" @click="changeTab(index)">{{ tab.label }}</a>
      </li>
    </ul>
    <component v-if="component" :is="component" />
  </div>
</template>
